import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RippleDirective } from './ripple/ripple.directive';
import { FileInputAccessor } from './file-control/file-input-accessor';
import { InputRestrictDirective } from './input-restrict/input-restrict.directive';
import { LangPipe } from './lang.pipe';
import { DropfileDirective } from './dropfile/dropfile.directive';
import { NamePipe } from './name.pipe';
import { SanitizeHtmlPipe } from './safeUrl';

@NgModule({
    declarations: [
        RippleDirective,
        FileInputAccessor,
        InputRestrictDirective,
        LangPipe,
        DropfileDirective,
        NamePipe,
        SanitizeHtmlPipe
    ],
    imports: [
        CommonModule,
    ],
    exports: [LangPipe,
        NamePipe,
        RippleDirective,
        FileInputAccessor,
        InputRestrictDirective,
        DropfileDirective,
        SanitizeHtmlPipe
    ]
})
export class DirectivesModule { }
